<template>
  <div class="education-column-section-block-component">
    <div class="education-column-section-block-header">
      <h2 v-if="title"
          class="education-column-section-block-title"
      >{{ title }}</h2>
      <span v-if="showMoreRoute"
            class="education-column-section-block-show-more"
            @click="handleShowMore"
      >更多 <ym-icon name="right" /></span>
    </div>

    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'EducationColumnSectionBlock',
    props: {
      title: String,
      showMoreRoute: Object,
    },
    methods: {
      handleShowMore() {
        const { showMoreRoute } = this;
        this.$router.push(showMoreRoute);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-section-block {
    &-component {
      margin-top: @size-large;
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 @size-base;
      margin-bottom: @size-base;
      line-height: 1;
    }

    &-title {
      position: relative;
      margin: 0;
      padding-left: @size-small;
      font-size: @education-column-section-block-title-font-size;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 8px;
        border-radius: @border-radius-normal;
        background-color: @color-primary-aide;
      }
    }

    &-show-more {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: @font-size-base;
      color: @color-text-lighter;
      .icon {
        font-size: @font-size-small;
        color: fade(@color-text-lighter, 20%);
      }
    }
  }
</style>
